'use strict';

const INTERACTION_CONSTANTS = {
  MAIL_SENT: 1,
  MAIL_CLICKED: 2,
  MAIL_OPENED: 3,
  CALLED: 4,
  NO_POTENTIAL: 5,
  APPOINTMENT: 6,
  MAIL_REPLIED: 7,
  MAIL_BOUNCED: 8,
  MAIL_BLOCKED:9,
  MAIL_AUTOREPLIED: 10,
  LINKEDIN_INVITATION_SENT: 11,
  LINKEDIN_MESSAGE_SENT: 12,
  LINKEDIN_INVITATION_ACCEPTED: 13,
};

export {
  INTERACTION_CONSTANTS,
};
